export const chartRangeE = {
  all: "all",
  oneM: "1m",
  sixM: "6m",
  oneY: "1y",
  ytd: "ytd",
};
